import { Button, Select, Space, Typography } from "antd";
import { Link } from "react-router-dom";
import PermissionCheck from "../../../Common/PermissionCheck";
import SearchFilter from "~components/SearchFilter/SearchFilter";
import { PermissionNames, PermissionOperations } from "~enums/permissions";

const FilterPanel = ({ setSearchText, handleStatus }) => {
  return (
    <Space style={{ display: "flex", justifyContent: "space-between" }} className={"mb-3"}>
      <Typography.Title style={{ alignSelf: "center", margin: 0 }} level={5}>
        Seasons
      </Typography.Title>
      <Space>
        <Select style={{ width: "100px" }} defaultValue={"ACTIVE"} onSelect={handleStatus}>
          <Select.Option value={"ALL"}>ALL</Select.Option>
          <Select.Option value={"COMPLETE"}>COMPLETE</Select.Option>
          <Select.Option value={"ACTIVE"}>ACTIVE</Select.Option>
          <Select.Option value={"DRAFT"}>DRAFT</Select.Option>
          <Select.Option value={"INACTIVE"}>INACTIVE</Select.Option>
          <Select.Option value={"PENDING"}>PENDING</Select.Option>
        </Select>
        <SearchFilter doSearch={setSearchText} />
        <PermissionCheck permissionKeys={[PermissionNames.SEASON]} permissionOptions={[PermissionOperations.CREATE]}>
          <Link to={`add`}>
            <Button type="primary" icon={<i className="fas fa-plus" style={{ marginRight: "5px" }} />}>
              Season
            </Button>
          </Link>
        </PermissionCheck>
      </Space>
    </Space>
  );
};

export default FilterPanel;
